import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import MaskedInput from 'react-maskedinput';
import {
  setClientValue,
  setVehiclesValue,
} from "../../../actions";
import { options } from "../../../operations";
import { getStreetsAsync } from '../../../operations/options';
import { Body, Gender, Text, InputCleave } from '../../Common/Form';
import { Select, Input, AsyncSelect } from '../../ui';
import Continue from "../../Common/Continue";
import {
  mapSelectList,
  containsNumberLetter,
  validLicensePlate
} from "../../../helpers";

import iconHouse from '../../../assets/icons/icon-house.svg';

class AutoForm_3 extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.continueCondition = this.continueCondition.bind(this);
    this.getFirstColumnContent = this.getFirstColumnContent.bind(this);
    this.getSecondColumnContent = this.getSecondColumnContent.bind(this);
  }

  componentDidMount() {
    const { getDepartments } = this.props;
    this.checkContinueState(null);
    getDepartments();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      gender, addressState,
      addressCity, addressStreet,
      is0Km, addressNumber,
      carMotor, carChassis,
      carMatricula, carPadron
    } = this.props;

    return (
      gender != '' &&
      addressState != null &&
      addressCity != null &&
      addressStreet != null &&
      addressNumber != '' &&
      containsNumberLetter(carMotor) &&
      containsNumberLetter(carChassis) &&
      (is0Km ||
        (!is0Km &&
          validLicensePlate(carMatricula) &&
          carPadron != ''
        )
      )
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getFirstColumnContent() {

    const {
      showError, gender, departments,
      onClientValueChange, streets,
      addressState, onDepartmentChange,
      addressCity, onCityChange,
      cities, addressStreet,
      getStreets, addressNumber,
      onStreetChange
    } = this.props;

    return (
      <div>
        <div className="AutosStandard-title">Datos personales:</div>
        <Gender
          showError= {showError}
          gender= {gender}
          onChange= {onClientValueChange}
        />
        <div className="AutosStandard-formRow">
          <div style={{ flex: 1 }}>
            <Select
              id="depto"
              leftIcon={iconHouse}
              name="depto"
              value={addressState}
              showAlert={showError && !addressState}
              onChange={onDepartmentChange}
              placeholder="Seleccione un departamento"
              options={mapSelectList(departments)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="city"
              leftIcon={iconHouse}
              name="city"
              value={addressCity}
              showAlert={showError && !addressCity}
              onChange={onCityChange}
              placeholder="Seleccione una ciudad"
              options={mapSelectList(cities)}
              noOptionsMessage={() => "Sin ciudades. Seleccione el Departamento primero."}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
        <div className="AutosStandard-formRow">
          <div style={{ flex: 1, paddingBottom: '4px' }}>
            <AsyncSelect
              id="address"
              leftIcon={iconHouse}
              name="calle"
              value={addressStreet}
              onChange={onStreetChange}
              placeholder="Seleccione una calle (*)"
              loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
              // cacheOptions
              showAlert={showError && !addressStreet}
              disabled={addressCity === null}
              noOptionsMessage={() =>
                'Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="addressNumber"
              name="addressNumber"
              placeholder="Nro. de puerta, manzana, solar"
              maxLength="50"
              type="text"
              value={addressNumber}
              onChange={(event) => { onClientValueChange('addressNumber', event.target.value) }}
              leftIcon={iconHouse}
              showAlert={showError && !addressNumber}
              autoComplete="nope"
            />
          </div>
        </div>
      </div>
    );
  }

  getSecondColumnContent() {

    const {
      showError, carMotor,
      onVehiclesValueChange,
      carChassis, is0Km,
      carMatricula, carPadron
    } = this.props;

    return (
      <div>
        <div className="AutosStandard-title">Datos del vehículo:</div>
        
        <div className="AutosStandard-options">
          <div className="AutosStandard-option">
            <Text className={showError && !carMotor ? 
              'AutosStandard-option-text AutosStandard-error' : 
              'AutosStandard-option-text'}
            >
              Motor 
            </Text>
            <div className='overwrite-input'>
              <Input
                id="carMotor"
                name="carMotor"
                maxLength="50"
                type="text"
                value={carMotor}
                onChange={(event) => { onVehiclesValueChange('carMotor', event.target.value) }}
                showAlert={showError && !carMotor}
                autoComplete="nope"
              />
              <span className="ex-text">ej. 123A</span>
            </div>
          </div>

          <div className="AutosStandard-option">              
            <Text className={showError && !carChassis ? 
              'AutosStandard-option-text AutosStandard-error' : 
              'AutosStandard-option-text'}
            >
              Chasis 
            </Text>
            <div className='overwrite-input'>
              <Input
                id="carChassis"
                name="carChassis"
                maxLength="50"
                type="text"
                value={carChassis}
                onChange={(event) => { onVehiclesValueChange('carChassis', event.target.value) }}
                showAlert={showError && !carChassis}
                autoComplete="nope"
              />
              <span className="ex-text">ej. AB1234</span>
            </div>
          </div>
        </div>
        
        <p className="AutosStandard-help">
          Estos datos están detallados en la libreta de propiedad del vehículo <strong>(deben contener letras y números)</strong>.
        </p>

        <div className="AutosStandard-checks">
          <Text className='AutosStandard-option-text'>
            ¿Es un 0 Km?
          </Text>
          <div className="AutosStandard-options-check">
            <div className="AutosStandard-option-check">
              <label htmlFor="yes"> <span>Si</span>
                <div className={`AutosStandard-radioWrapper ${is0Km ? 'AutosStandard-radioWrapper--on' : ''}`}>
                  <input 
                    type="radio" 
                    name="is0Km" 
                    id="yes" 
                    value="true" 
                    checked={is0Km}
                    onChange={() => { onVehiclesValueChange('is0Km', true) }} 
                  />
                </div>
              </label>
            </div>
            <div className="AutosStandard-option-check">
              <label htmlFor="no"> <span>No</span>
                <div className={`AutosStandard-radioWrapper ${!is0Km ? 'AutosStandard-radioWrapper--on' : ''}`}>
                  <input 
                    type="radio" 
                    name="is0Km" 
                    id="no" 
                    value="false" 
                    checked={!is0Km}
                    onChange={() => { onVehiclesValueChange('is0Km', false) }} 
                  />
                </div>
              </label>
            </div>
          </div>
        </div>

        <div className={`AutosStandard-options AutosStandard-transition ${is0Km ? 'AutosStandard-disabled' : '' }`}>
          <div className="AutosStandard-option">
            <Text className={showError && !is0Km  && !carMotor ? 
              'AutosStandard-option-text AutosStandard-error' : 
              'AutosStandard-option-text'}
            >
              Matrícula 
            </Text>
            <div className='overwrite-input'>
              <InputCleave
                id="carMatricula"
                name="carMatricula"
                maxLength="50"
                type="text"
                disabled={is0Km}
                mask="AAA 1111"                
                value={!is0Km ? carMatricula : ''}
                options={{blocks: [3, 4], uppercase: true}}
                onChange={(event) => { onVehiclesValueChange('carMatricula', event.target.value) }}
                showAlert={showError && !is0Km && !carMatricula}
                autoComplete="nope"
              />
              <span className="ex-text">ej. AAA 1111</span>
            </div>
          </div>

          <div className="AutosStandard-option">              
            <Text className={showError && !is0Km  && !carChassis ? 
              'AutosStandard-option-text AutosStandard-error' : 
              'AutosStandard-option-text'}
            >
              Padrón 
            </Text>
            <div className='overwrite-input'>
              <Input
                id="carPadron"
                name="carPadron"
                maxLength="50"
                type="text"
                disabled={is0Km}
                value={!is0Km ? carPadron : ''}
                showAlert={showError && !is0Km && !carPadron}
                onChange={(event) => { onVehiclesValueChange('carPadron', event.target.value) }}
                autoComplete="nope"
              />
              <span className="ex-text">ej. 4456783</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <Text style={{ paddingTop: '30px', fontSize: '1.2em'}} className="Text-question">
          Para contratar esta cobertura completá los siguientes datos
        </Text>
        <Body columnContent={this.getFirstColumnContent}  />
        <Body columnContent={this.getSecondColumnContent} />
        <Continue state={toContinue} text="Comprar"/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    gender: state.client.gender,
    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,

    carMotor: state.vehicles.carMotor,
    carChassis: state.vehicles.carChassis,
    is0Km: state.vehicles.is0Km,
    carMatricula: state.vehicles.carMatricula,
    carPadron: state.vehicles.carPadron,

    departments: state.options.departments,
    cities: state.options.cities,
    streets: state.options.streets,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    onClientValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    onVehiclesValueChange: (type, value) => {
      dispatch(setVehiclesValue(type, value));
    },
    onDepartmentChange: (addressState) => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: (addressCity) => {
      dispatch(options.setCity(addressCity));
    },
    getStreets: (val, callback) => {
      dispatch(options.getStreets(val, callback));
    },
    onStreetChange: (addressStreet) => {
      dispatch(setClientValue('addressStreet', addressStreet));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoForm_3);